export const CANVAS_SIZE = {
  width: 750,
  height: 1450, // ⬅️ 拉长，匹配真实凭证比例
};

export const TEXT_CONFIG = {
  // 金额
  amount: {
    x: 375,
    y: 500,
    fontSize: 40,
    fontWeight: 700,
    align: 'center',
    color: '#FFFFFF',
  },

  // 时间
  time: {
    x: 375,
    y: 560,
    fontSize: 28,
    align: 'center',
    color: '#c8c8c8',
  },

  // Para
  name: {
    x: 680,
    y: 800,
    align: 'right',
    fontSize: 28,
    fontWeight: 700,
  },

  cuit: {
    x: 680,
    y: 864,
    align: 'right',
    fontSize: 26,
    fontWeight: 700,
  },

  cbu: {
    x: 680,
    y: 928,
    align: 'right',
    fontSize: 26,
    fontWeight: 700,
  },

  // COELSA
  coelsaId: {
    x: 75,
    y: 1095,
    fontSize: 32,
    fontWeight: 700,
  },

  // Transaction ID
  transactionId: {
    x: 75,
    y: 1195,
    fontSize: 32,
    fontWeight: 700,
  },
} as const;
